import { useTranslation } from 'react-i18next'

import { Toolbar, Item } from 'devextreme-react/toolbar'
import { Button } from 'devextreme-react/button'

import { Form, Field } from 'formik'

import { Link, useNavigate } from 'react-router-dom'

import { useIxAuth } from 'contexts/auth-context'
import {
    BaseForm,
    IxLangToggle,
    TextInput,
    ErrorPanel
} from 'components'
import {useEffect} from 'react'

const ssoLoginSchema = {
    $schema: 'http://json-schema.org/draft-07/schema',
    $id: 'http://example.com/example.json',
    type: 'object',
    properties: {
        email: {
            type: 'string',
            minLength: 1
        },
    },
    required: ['email']
}


export const SsoLoginForm = () => {
    const { ssoLogin, error } = useIxAuth()
    const { t } = useTranslation()

    const formikProps = {
        initialValues: { email: null },
        jsonSchema: ssoLoginSchema,
        ajvOptions: {
            coerceTypes: true,
            $data: true,
        },
        onSubmit: (values: any) => {
            ssoLogin && ssoLogin(values)
        },
    }

    return (
        <div className='rb-container' style={ { height: '100%' } }>
            <BaseForm {...formikProps}>
                {() => (
                    <Form id='sso-login-form'>
                        { error ? <ErrorPanel err={ error as string | undefined } /> : null }
                        <Field as={TextInput} name='email' label={t('global:field.EMAIL')}/>
                        <Button useSubmitBehavior={true} elementAttr={{ style: 'margin-left: 1rem;'}} type='default'>{t('global:button.login')}</Button>
                    </Form>
                )}
            </BaseForm>
            <Link style={ { position: 'absolute', bottom: '1rem', right: '1rem' } } to='/login'>Login with username and password</Link>
        </div>
    )
}


export const SsoLoginTitle = () => {
    const { t } = useTranslation()
    return (
        <Toolbar elementAttr={{style: 'border-bottom: none !important;'}}>
            <Item location='before' text={t('global:label.ssoLogin')} />
            <Item location='after' component={IxLangToggle} />
        </Toolbar>
    )
}


export const SsoLogin = () => {
    return (
        <div className='ix-login-overlay'>
            <div className='ix-login-panel'>
                <div className='dx-popup-title'>
                    <SsoLoginTitle />
                </div>
                <div className='dx-popup-content'>
                    <SsoLoginForm />
                </div>
            </div>
        </div>
    )
}

export const SsoRedirect = () => {
    const { getSsoToken } = useIxAuth()
    const navigate = useNavigate()

    useEffect(() => {
        const params = new URLSearchParams(window.location.search)
        const code = params.get('code')

        if (code) {
            getSsoToken(code).then(() => { navigate('/') }).catch((e) => { navigate('/sso-login') })
        } else {
            navigate('/sso-login')
        }
    }, [getSsoToken, navigate])

    return null
}
